/* eslint-disable react/display-name */
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ContentBody, Table } from '../../../../core/components'
import { routesConfig } from '../../../../core/configs/routes'
import { Pagination } from '../../../../entities'
import useCustomerContracts from '../../../../services/queries/customer/useCustomerContracts'
import { dateFormat } from '../../../../utils/format/dateFormat'

export const ContractsTab = () => {
  const { id }: any = useParams()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const { data, error, isLoading }: any = useCustomerContracts({
    ...pagination,
    id
  })
  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  const columns = [
    {
      title: 'Situação',
      dataIndex: 'situation',
      key: 'situation'
    },
    {
      title: 'Nº Contrato',
      dataIndex: 'id',
      key: 'id',
      render: (value: any, row: any) => {
        return (
          <Link
            to={routesConfig.contracts.contract.datails + `/${row.id}/detalhes`}
          >
            {value}
          </Link>
        )
      }
    },
    {
      title: 'Data Início',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (value: string) => dateFormat(value)
    },
    {
      title: 'Data Final',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (value: string) => dateFormat(value)
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description'
    }
  ]

  return (
    <>
      <ContentBody>
        {/* <Row style={{ marginBottom: 10, marginTop: 10 }}>
          <Col>
            <Input
              label='Pesquisa'
              placeholder='Pesquisar por nº contrato, descrição, situação...'
              style={{ width: '385px', marginBottom: 20 }}
            />
          </Col>
          <Col>
            <Button htmlType='submit' type='primary' style={{ width: 100 }}>Procurar</Button>
            <Button style={{ marginLeft: 10 }}>Reiniciar</Button>
          </Col>
        </Row> */}
        <Table
          columns={columns}
          dataSource={data?.data}
          bordered
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
        />
      </ContentBody>
    </>
  )
}
